import { createContext, ReactNode } from 'react'

interface IContextProps {
  handleOpen: () => void
}

export const AccountManualModalContext = createContext<IContextProps>({ handleOpen: () => { } })

interface IProps {
  handleOpen: () => void
  children: ReactNode
}

export const AccountManualContextProvider = ({ children, handleOpen }: IProps) => {
  return (
    <AccountManualModalContext.Provider value={{ handleOpen }}>
      {children}
    </AccountManualModalContext.Provider>
  )
}
